module.exports = "<app-home [userId]='userId'></app-home>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 533
// module chunks = 1